"use strict";

var GoogleCalendarTitle = require("./google-calendar-title");
var GoogleCalendarDescription = require("app/screens/Integration/components/GoogleCalendar/google-calendar-description");
var IntegrationLogo = require("app/screens/Integration/shared/components/integration-logo");

var GoogleCalendarIntegration = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  render: function() {
    var googleCalendarLogo = {
      logoHref: "http://calendar.google.com",
      logoSrc: "/skins/sistema/page/integracoes/imagens/google-calendar.png"
    };

    return (
      <fieldset>
        <GoogleCalendarTitle />
        <div className="fieldContent">
          {IntegrationLogo(googleCalendarLogo)}
          <div className="left-gray-border integrationGuide">
            <GoogleCalendarDescription />
            {this.props.children}
          </div>
        </div>
      </fieldset>
    );
  }
});

module.exports = GoogleCalendarIntegration;



// WEBPACK FOOTER //
// ./app/screens/Integration/components/GoogleCalendar/google-calendar-integration.jsx